import { render, staticRenderFns } from "./m-page-title.vue?vue&type=template&id=3f223632&scoped=true"
import script from "./m-page-title.vue?vue&type=script&lang=js"
export * from "./m-page-title.vue?vue&type=script&lang=js"
import style0 from "./m-page-title.vue?vue&type=style&index=0&id=3f223632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f223632",
  null
  
)

export default component.exports